import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';
import { filter, get, isEmpty, isEqual, keyBy, map } from 'lodash';
import Assessments from './Assessments';
import Button from '../../../common/components/Button';
import ModalX from '../../../common/svgs/ModalX';
import { getApplicantAssessmentTests } from '../../../redux/actionCreators/async';
import { updateApplicantAssessments } from '../../../redux/actionCreators/async/assessments';
import * as documentApi from '../../../redux/actionCreators/async/documents';

@connect((store) => ({
  documents : store.documents,
  applicant : store.applicantProfile,
  staticData : store.staticData
}))
export default class AssessmentsContainer extends Component {
  static propTypes = {
    dispatch    : PropTypes.func.isRequired,
    documents   : PropTypes.object.isRequired,
    applicant   : PropTypes.object.isRequired,
    style       : PropTypes.object,
    stateToggle : PropTypes.func
  }

  constructor(props) {
    super(props);

    this.state = {
      tests : {}
    };
  }

  componentWillMount() {
    if (!isEmpty(this.props.applicant)) {
      this.refreshAssessments(this.props.applicant);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.applicant && !isEqual(nextProps.applicant, this.props.applicant)) {
      this.refreshAssessments(nextProps.applicant);
    }
  }

  newState() {
    return Object.assign({}, this.state);
  }

  handleUpdateAssessmentScore = (event, testId, score, value) => {
    const state = this.newState();
    const testScore = state.tests[testId];
    if (testScore) {
      testScore.dirty = true;
      testScore[score] = value;
      state.tests[testId] = testScore;
      this.setState(state);
    }
  }

  handleUploadDocument = (testId, clientId, fileInfo) => {
    if (testId && clientId && !isEmpty(fileInfo)) {
      this.saveDocument(get(this.props, 'applicant.id'), testId, clientId, fileInfo);
    }
  }

  handleDeleteDocument = (testId, clientId) => {
    if (testId && clientId) {
      this.deleteDocument(get(this.props, 'applicant.id'), testId, clientId);
    }
  }

  handleSaveScores = () => {

    const { tests } = this.newState();
    if (tests) {

      const dirtyTests = filter(tests, test => test.dirty)
        .map(test => ({
          applicantId : get(this.props, 'applicant.id'),
          testId      : test.id,
          documentId  : test.documentId,
          rawScore    : test.rawScore,
          percentile  : test.percentile,
          result      : test.result
        }));
      this.saveAssessments(this.props.applicant, dirtyTests);
    }

  }

  handleCloseScores = () => {
    if (this.props.stateToggle) {
      this.props.stateToggle('edit', 0);
    }
  }

  deleteDocument(applicantId, testId, clientId) {

    const {dispatch} = this.props;

    if (applicantId && testId && clientId) {
      dispatch(
        documentApi.deleteApplicantDocument(applicantId, clientId, (err) => {
          if (err) {
            return console.error(err);
          }

          this.handleUpdateAssessmentScore(null, testId, 'documentId', null);
        })
      );
    }
  }

  saveDocument(applicantId, testId, clientId, fileInfo) {

    const { dispatch } = this.props;
    const assessmentDocumentType = this.props.staticData.applicantDocumentFileTypes.find((ft) => ft.name==="Assessment").id;
    if (applicantId && clientId && fileInfo) {
      const docInfo = {
        applicantId,
        clientId,
        storagePath : fileInfo.nameWithFolder,
        fileName    : fileInfo.name,
        fileSize    : fileInfo.size,
        fileTypeId  : assessmentDocumentType
      };

      dispatch(
        documentApi.createApplicantDocument(applicantId, clientId, docInfo, (err, id) => {
          this.handleUpdateAssessmentScore(null, testId, 'documentId', id);
          this.handleUpdateAssessmentScore(null, testId, 'fileName', fileInfo.name);
        })
      );
    }

  }

  saveAssessments(applicant, assessments) {

    const  { dispatch } = this.props;

    if (applicant && !isEmpty(assessments)) {
      dispatch(
        updateApplicantAssessments(applicant.id, assessments, (err) => {
          if (err) {
            return console.error(err);
          }

          this.handleCloseScores();
        })
      );
    }

  }

  refreshAssessments(applicant) {

    const { dispatch } = this.props;

    if (applicant) {
      dispatch(
        getApplicantAssessmentTests(get(applicant, 'id'), (err, assessmentTests) => {
          if (err) {
            return console.error(err);
          }

          const tests = keyBy(assessmentTests, 'id');
          this.setState(Object.assign({}, this.state, {tests}));
        })
      );
    }

  }

  isFormDirty = () => {
    const { tests } = this.newState();
    const dirty = filter(tests, test => !!test.dirty);
    return !!isEmpty(dirty);
  }

  renderAssessments(state, props) {

    const tests = map(state.tests, test => test);
    const documents = map(props.documents, doc => doc);

    return (
      <Assessments
        tests={tests}
        documents={documents}
        onChange={this.handleUpdateAssessmentScore}
        onUpload={this.handleUploadDocument}
        onRemove={this.handleDeleteDocument}
      />
    );

  }

  renderForm(state, props) {

    return (
      <div className='score-card'
        key={`Assessments Card ${props.applicant.id}`}
        style={props.style}>
        <ModalX onClick={this.handleCloseScores}/>
        <div className='top-wrapper clearfix'>
          <div className='title'>Assessment Scores</div>
        </div>
        {
          this.renderAssessments(state, props)
        }
        <Button
          label='Save'
          onClick={this.handleSaveScores}
          disabled={this.isFormDirty()}
          style={{
            display: 'inline-block',
            width: 'auto',
            paddingLeft: '50px',
            paddingRight: '50px',
            marginTop: '50px',
            float: 'right'
          }}/>
      </div>
    );

  }

  render() {

    if (isEmpty(this.state.tests)) {
      return (
        <div className='score-card' style={this.props.style}>
          <ModalX onClick={this.handleCloseScores}/>
          <div className='top-wrapper clearfix'>
            <div className='title'>No Assessments Are Available Yet</div>
          </div>
        </div>
      );
    }

    return this.renderForm(this.state, this.props);

  }

}



// WEBPACK FOOTER //
// ./shared/react/admin/Applicant/AssessmentsContainer.js